var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container shadow-md"},[_c('button',{staticClass:"container__holder",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"container__image",attrs:{"src":_vm.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }